import Kendra from 'aws-sdk/clients/kendra';
import { CREDENTIALS_FILE_NAME, CREDENTIALS_FILE_PATH } from './constants';
import S3 from 'aws-sdk/clients/s3';
import { getStage, Stage } from 'src/helpers';

const _loadingErrors = [];
let _indexId: string;
let _kendraClient: Kendra | undefined;
let _s3Client: S3 | undefined;

const stage = getStage();
if (stage === Stage.TEST) {
    let config = null;
    try {
        config = require(`./${CREDENTIALS_FILE_NAME}`);
    } catch {
        _loadingErrors.push(
            `${CREDENTIALS_FILE_PATH}/${CREDENTIALS_FILE_NAME} could not be loaded. See Getting Started in the README.`
        );
    }

    if (config) {
        if (!config.accessKeyId) {
            _loadingErrors.push(
                `There is no accessKeyId provided in${CREDENTIALS_FILE_PATH}/${CREDENTIALS_FILE_NAME}`
            );
        }
        if (!config.secretAccessKey) {
            _loadingErrors.push(
                `There is no secretAccessKey provided in ${CREDENTIALS_FILE_PATH}/${CREDENTIALS_FILE_NAME}`
            );
        }
        if (!config.sessionToken) {
            _loadingErrors.push(
                `There is no sessionToken provided in ${CREDENTIALS_FILE_PATH}/${CREDENTIALS_FILE_NAME}`
            );
        }
        if (!config.region) {
            _loadingErrors.push(
                `There is no region provided in ${CREDENTIALS_FILE_PATH}/${CREDENTIALS_FILE_NAME}`
            );
        }
        if (!config.indexId || config.indexId.length === 0) {
            _loadingErrors.push(
                `There is no indexId provided in ${CREDENTIALS_FILE_PATH}/${CREDENTIALS_FILE_NAME}`
            );
        }
    }

    const hasErrors = _loadingErrors.length > 0;
    if (hasErrors) {
        console.error(JSON.stringify(_loadingErrors));
    }
    _indexId = config ? config.indexId : undefined;
    _kendraClient = !hasErrors
        ? new Kendra({
              accessKeyId: config.accessKeyId,
              secretAccessKey: config.secretAccessKey,
              sessionToken: config.sessionToken,
              region: config.region,
          })
        : undefined;
    _s3Client = !hasErrors
        ? new S3({
              accessKeyId: config.accessKeyId,
              secretAccessKey: config.secretAccessKey,
              sessionToken: config.sessionToken,
              region: config.region,
          })
        : undefined;
} else {
    _indexId = '00b3a993-824a-4b72-92de-878a419d4922';
    const region = 'us-west-2';
    _kendraClient = new Kendra({ region });
    _s3Client = new S3({});
}

export const errors = _loadingErrors;
export const indexId = _indexId;
export const kendraClient = _kendraClient;
export const s3 = _s3Client;
